import { format } from 'date-fns';
import { getUser } from '../store/User';

export const fileNameHelper = (page: string) => {
  const { account_name: accountName } = getUser();
  const date = format(new Date(), 'yyyy-MM-dd');
  return `${page}.${accountName?.replace(/ /g, '_')}.${date}`;
};
